<template>
    <BModal
        id="des-modal"
        v-model="modalShow"
        :no-close-on-backdrop="true"
        dialog-class="modal-dialog-left modal-lg"
        body-class="p-3"
        size="xl"
    >
        <template #header>
            <h2 class="m-0">Створити другий тур</h2>
            <div class="panel-toolbar pr-3 pb-2 align-self-end">
                <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0" @click="close">
                    <i class="fal fa-times"></i>
                </button>
            </div>
        </template>
        
        <div class="d-flex align-items-center gap-3 mb-2">
            <p>
                <BButton class="mr-3" variant="outline-primary" size="sm" @click="selectAllSub">Всі</BButton>
                <BButton size="sm" @click="clearSelectedSub">Очистити</BButton>
            </p>
        </div>
        
        <BTable bordered
            ref="invitations"
            selectable
            select-mode="multi"
            primary-key="user_id"
            @update:selected-items="onSelectedItems"
            :items="tableItems"
            :fields="fields"
            show-empty
        >
            
            <template #cell(selected)="{ rowSelected }">
                <span aria-hidden="true">{{ rowSelected ? '✓' : '' }}</span>
            </template>
            
            <template #cell(company)="{ item }">
                <span class="fw-semibold">{{ item.company }}</span>
            </template>
            
            <template #cell(participant)="{ item }">
                <span class="text-muted">{{ item.email || '—' }}</span>
            </template>
        </BTable>
        
        <yes_no
            key="protocol_n_type"
            @update:modelValue="form.type"
            v-model="form.type"
            base_class=""
            title="Тип тендера"
            :radio_options="typeOptions">
        </yes_no>
        
        <yes_no
            key="protocol_n_currency"
            @update:modelValue="form.currency"
            v-model="form.currency"
            base_class=""
            title="Валюта"
            :radio_options="currencyOptions">
        </yes_no>
        
        <div class="step">
            <label class="form-label">Крок пониження</label>
            <BFormInput v-model=form.step  type="number" step="0.01" placeholder="0" />
        </div>
 
        
        <template #footer>
            <BButton :disabled="!canSend" size="xl" variant="outline-primary" @click="createSecondTour">
                Створити
            </BButton>
        </template>
    </BModal>
</template>

<script>
import {
    BModal, BButton, BTable, BFormCheckbox, BFormSelect, BFormInput
} from 'bootstrap-vue-next'
import Yes_no from "../../../../base/yes_no.vue";

export default {
    name: 'protocol_new_tour',
    components: {Yes_no, BModal, BButton, BTable, BFormCheckbox, BFormSelect, BFormInput },
    props: { protocol: { type: Object, required: true } },
    emits: ['send'],
    
    data () {
        return {
            modalShow: false,
            items: [],
            selectedUsers: [],
            selectMode: 'multi',
            form: {
                type: 'second_simple',
                currency: '',
                step: 0
            },
            
            fields: [
                { key: 'company',     label: 'Організація' },
                { key: 'participant', label: 'Учасник' }
            ]
        }
    },
    
    created () {
        EventBus.$on('show_new_tour', this.show_new_tour)
        this.buildItems()
    },
    
    watch: {
        protocol: { handler () { this.buildItems() }, deep: true }
    },
    
    methods: {
        
        selectAllSub() {
            this.$refs.invitations.selectAllRows();
        },
        
        onSelectedItems(items) {
            this.selectedUsers = items
        },
        
        clearSelectedSub() {
            this.$refs.invitations.clearSelected()
        },
        
        buildItems () {
            const members = this.protocol?.members || []
            const apps = this.protocol?.applications_info || []
            const emailByAuthor = {}
            apps.forEach(a => { emailByAuthor[String(a.author_id)] = a.email || a.contact_email || '' })
            
            this.items = members.map(m => ({
                user_id: m.author_id,
                company: m.company,
                email: emailByAuthor[String(m.author_id)] || ''
            }))
            
            
            this.selectedUsers = []
            this.$nextTick(() => this.$refs.table?.clearSelected?.())
        },
        
        toggleAll (checked) {
            if (checked) {
                this.$refs.table?.selectAllRows?.()
            } else {
                this.$refs.table?.clearSelected?.()
            }
        },
        
        show_new_tour () {
            this.form = { type: 'second_simple', currency: 1, step: 0 }
            this.modalShow = true;
            this.buildItems();
        },
        
        close () { this.modalShow = false },
        
        async createSecondTour () {
            if (!this.canSend) return
            const payload = {
                users       : this.selectedUsers,
                type        : this.form.type,
                currency    : this.form.currency,
                step        : Number(this.form.step || 0)
            }
            let url = '/tenders/sales/tenders/' + parseInt(this.protocol.tender_item_id) + "/protocol" + "/" + this.protocol.id + "/new_tender";
            IMC_CORE.showloading();
            await api.put(url,payload).then(({data}) => {
                this.is_load = false;
                IMC_CORE.hideloading();
                
                let tender_id = parseInt(data.data);
                if(tender_id > 0) {
                    window.location.href ="/tender/edit/" + tender_id;
                }
                
            }).catch(({response}) => {
                this.is_load = false;
                IMC_CORE.hideloading();
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status,
                })
            });
            
        }
    },
    
    computed: {
        tableItems () { return this.items },
        
        canSend () {
            return this.selectedUsers.length > 0
        },
        
        typeOptions () {
            return [
                { value: 'second_simple',  text: 'Тендер' },
                { value: 'second_reduction', text: 'Редукціон' },
              //  { value: 'second_auction', text: 'Аукціон' }
            ]
        },
        
        currencyOptions () {
            return [
                { value: 1, text: 'грн' },
                { value: 2, text: 'usd' },
                { value: 3, text: 'eur' }
            ]
        }
    },
    
    
}
</script>

<style scoped>

</style>
